import { useEffect, useState } from 'react';
import { api } from '../api';

export default function AttendanceGroups() {
  const [list, setList] = useState<any[]>([]);
  const [depts, setDepts] = useState<any[]>([]);
  const [form, setForm] = useState<any>(null);
  const [msg, setMsg] = useState('');

  const load = () => {
    api('/attendance/groups').then(setList).catch(() => {});
    api('/departments').then(setDepts).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const blank = () => ({
    id: null, name: '', department_id: '', work_start: '09:00', work_end: '18:00',
    late_minutes: 0, center_lat: '', center_lng: '', radius: 300,
  });

  const save = async () => {
    try {
      const body = {
        ...form,
        department_id: form.department_id ? Number(form.department_id) : null,
        late_minutes: Number(form.late_minutes) || 0,
        center_lat: form.center_lat ? Number(form.center_lat) : null,
        center_lng: form.center_lng ? Number(form.center_lng) : null,
        radius: Number(form.radius) || 300,
      };
      if (form.id) {
        await api(`/attendance/groups/${form.id}`, { method: 'PUT', body: JSON.stringify(body) });
      } else {
        await api('/attendance/groups', { method: 'POST', body: JSON.stringify(body) });
      }
      setMsg('✅ 已保存');
      setForm(null);
      load();
      setTimeout(() => setMsg(''), 2500);
    } catch (e: any) {
      setMsg('❌ ' + e.message);
    }
  };

  const del = async (id: number) => {
    if (!confirm('确认删除该考勤组？')) return;
    await api(`/attendance/groups/${id}`, { method: 'DELETE' });
    load();
  };

  return (
    <div className="space-y-4 max-w-2xl mx-auto">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">考勤组管理</h2>
        <button onClick={() => setForm(blank())} className="bg-brand-600 text-white rounded px-3 py-2 text-sm hover:bg-brand-700">+ 新建考勤组</button>
      </div>

      {msg && <div className={`rounded p-2 text-sm ${msg.includes('✅') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{msg}</div>}

      {/* 列表 */}
      <div className="bg-white rounded-xl shadow divide-y">
        {list.map((g) => (
          <div key={g.id} className="p-3 flex items-center justify-between">
            <div>
              <div className="font-medium">{g.name} {g.department_name && <span className="text-xs text-slate-400">（{g.department_name}）</span>}</div>
              <div className="text-xs text-slate-400">
                {g.work_start}-{g.work_end} · 迟到容限 {g.late_minutes} 分 ·
                {g.center_lat != null ? ` 围栏 ${g.radius}m @${g.center_lat.toFixed(4)},${g.center_lng.toFixed(4)}` : ' 不限位置'}
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setForm({ ...g, department_id: g.department_id ?? '' })} className="text-xs text-brand-600 border border-brand-200 rounded px-2 py-1">编辑</button>
              <button onClick={() => del(g.id)} className="text-xs text-red-500 border border-red-200 rounded px-2 py-1">删除</button>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="p-6 text-center text-slate-400">暂无考勤组</div>}
      </div>

      {/* 表单 */}
      {form && (
        <div className="bg-white rounded-xl shadow p-4 space-y-3">
          <h3 className="font-bold">{form.id ? '编辑考勤组' : '新建考勤组'}</h3>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-sm">名称<input className="w-full border rounded px-2 py-1.5 mt-1" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></label>
            <label className="text-sm">适用部门
              <select className="w-full border rounded px-2 py-1.5 mt-1" value={form.department_id} onChange={(e) => setForm({ ...form, department_id: e.target.value })}>
                <option value="">全公司</option>
                {depts.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
              </select>
            </label>
            <label className="text-sm">上班时间<input type="time" className="w-full border rounded px-2 py-1.5 mt-1" value={form.work_start} onChange={(e) => setForm({ ...form, work_start: e.target.value })} /></label>
            <label className="text-sm">下班时间<input type="time" className="w-full border rounded px-2 py-1.5 mt-1" value={form.work_end} onChange={(e) => setForm({ ...form, work_end: e.target.value })} /></label>
            <label className="text-sm">迟到容限(分)<input type="number" className="w-full border rounded px-2 py-1.5 mt-1" value={form.late_minutes} onChange={(e) => setForm({ ...form, late_minutes: e.target.value })} /></label>
            <label className="text-sm">允许半径(米)<input type="number" className="w-full border rounded px-2 py-1.5 mt-1" value={form.radius} onChange={(e) => setForm({ ...form, radius: e.target.value })} /></label>
            <label className="text-sm">围栏中心纬度<input className="w-full border rounded px-2 py-1.5 mt-1" placeholder="如 39.9087" value={form.center_lat} onChange={(e) => setForm({ ...form, center_lat: e.target.value })} /></label>
            <label className="text-sm">围栏中心经度<input className="w-full border rounded px-2 py-1.5 mt-1" placeholder="如 116.3975" value={form.center_lng} onChange={(e) => setForm({ ...form, center_lng: e.target.value })} /></label>
          </div>
          <p className="text-xs text-slate-400">提示：留空纬经度表示「不限位置」；填写后仅允许在半径范围内打卡，超出记为外勤。</p>
          <div className="flex gap-2">
            <button onClick={save} className="bg-brand-600 text-white rounded px-4 py-2 text-sm">保存</button>
            <button onClick={() => setForm(null)} className="border rounded px-4 py-2 text-sm">取消</button>
          </div>
        </div>
      )}
    </div>
  );
}
